<script>

  import { External } from '../../external';
  import { onDestroy, onMount } from 'svelte';
  import { ignore, makeWebsiteRequest } from '../../Common/tools';

  export let amount, futureAmount, currency, settings;

  let elements, cardInstance, session, intent, stripeUi, activeBillingDetails;

  export const completeRequiredSetupActions = async () => {
    return completeRequiredPaymentActions();
  }

  export const completeRequiredPaymentActions = async () => {
    if (!elements) {
      return;
    }

    External.CPanel.disableUI(true);
    let method = intent && intent.startsWith('seti') ? PlatformStripeInstance.confirmSetup : PlatformStripeInstance.confirmPayment;
    return method({
      elements: elements,
      confirmParams: {
        return_url: `https://${External.userDomain}/_service/processing?type=stripe-billing`,
        payment_method_data: {
          billing_details: activeBillingDetails || {}
        }
      }
      //redirect: 'if_required'
    }).then(function(result) {
      External.CPanel.enableUI();
      External.Log.log(result);
      if (result.error) {
        External.Tools.showError(result.error.message || result.error.code || result.error.decline_code || result.error);
      }
    });
  };

  export const onAmountChange = () => {
    setup(); // refreshes the payment intent
  };

  export const getPaymentDetails = async (billingInfo) => {
    return new Promise(async (resolve, reject) => {
      activeBillingDetails = {
        name: billingInfo.name || '',
        email: External.userEmail
      };

      if (billingInfo.countryCode) {
        activeBillingDetails.address = {};
        if (billingInfo.countryCode === 'UK')
          activeBillingDetails.address.country = 'UK';
        else if (billingInfo.countryCode === 'EL')
          activeBillingDetails.address.country = 'GR';
        else
          activeBillingDetails.address.country = billingInfo.countryCode;
        if (billingInfo.zip)
          activeBillingDetails.address.postal_code = billingInfo.zip;
        if (billingInfo.state)
          activeBillingDetails.address.state = billingInfo.state;
        if (billingInfo.city)
          activeBillingDetails.address.city = billingInfo.city;
        if (billingInfo.address)
          activeBillingDetails.address.line1 = billingInfo.address;
      }

      resolve({
        nonce: intent
      });
    });
  };

  let setup = async () => {
    External.CPanel.disableUI(true);
    let amountToAuthorize = Math.max(0, amount);
    let result = await makeWebsiteRequest({
      action: 'getStripeClientToken',
      data: {
        amount: amountToAuthorize
      }
    });

    if (!result.ok) {
      External.CPanel.enableUI();
      return;
    }

    let token = result.data.token;
    let pk = result.data.platformPublishableKey;
    let accountId = result.data.stripeConnectAccountId;

    if (!window.PlatformStripeInstance) {
      window.PlatformStripeInstance = window.Stripe(pk, {
        stripeAccount: accountId
      });
    }

    if (!session) {
      session = {};
    }

    if (amountToAuthorize > 0) {
      if (session.type !== 'payment') {
        // we had a SetupIntent and now require a payment - recreate the elements for a PaymentIntent
        elements = null;
      }
      session.type = 'payment';
      if (session.token !== token) {
        session.token = token;
        window.PlatformStripeInstance.retrievePaymentIntent(token).then((result) => {
          if (result.paymentIntent) {
            intent = result.paymentIntent.id;
          }
        }, ignore);
      }
    } else {
      if (session.type !== 'setup') {
        // we had a SetupIntent and now require a payment - recreate the elements for a PaymentIntent
        elements = null;
      }

      session.type = 'setup';
      if (session.token !== token) {
        session.token = token;
        window.PlatformStripeInstance.retrieveSetupIntent(token).then((result) => {
          if (result.setupIntent) {
            intent = result.setupIntent.id;
          }
        });
      }
    }

    if (elements) {
      // we already have an elements instance - fetch updates.
      elements.fetchUpdates();
    } else {
      elements = window.PlatformStripeInstance.elements({
        appearance: {
          theme: 'stripe'
        },
        clientSecret: token,
        locale: External.WebPlatform.getStripeLocale(External.userLocale)
      });

      let billingDetailsToSkip = {
        name: 'never',
        email: 'never',
        ...(window.stripeSkipBillingFields || {})
      };
      //window.stripeSkipBillingFields = { address: { country: 'never' } };

      cardInstance = elements.create('payment', {
        terms: window.stripeTermsSettings || {
          card: 'never'
        },
        fields: {
          billingDetails: billingDetailsToSkip
        }
      });
      cardInstance.mount(stripeUi);
    }
    External.CPanel.enableUI();
  };

  let teardown = () => {
    if (cardInstance !== null) {
      try {
        cardInstance.destroy();
        cardInstance = null;
        elements = null;
        session = null;
        intent = null;
      } catch (error) {
      }
    }
  };

  onMount(() => {
    External.WebPlatform.requestScripts([{
      script: 'https://js.stripe.com/v3/',
      check: () => !External.isUndefined(window.Stripe)
    }], setup);
  });

  onDestroy(teardown);
</script>

<div class="payment-info">
  <div class="col20 f-left card-form">
    <div class="col20 f-left boxed stripe-ui" bind:this={stripeUi} style="box-sizing: border-box;"></div>
  </div>
</div>
